import React from "react";
import dynamic from "next/dynamic";
import Banner from "./banner/Banner";
import Trusted from "../../Home/Trusted";
import { AwardsBlock, TrustedByBlock } from "../../Home";
const Awards = dynamic(() => import("../../Home/Awards"), { ssr: true });
const ContactSection = dynamic(() => import("./ContactSection"), { ssr: true });

interface RequestProposalProps {
  blocks: any;
}

const LocateUS: React.FC<RequestProposalProps> = ({ blocks }) => {
  return (
    <>
      <div className="nome-new rfp_new bg-one">
        {blocks?.blocks?.map((block: any, i: number) => {
          switch (block?.__component) {
            case "blocks.2025-career-banner":
              return (
                <Banner
                  key={i}
                  block={block}
                  breadcrumbs={blocks.breadcrumbs}
                />
              );

            case "blocks.2025-locate-us-offices":
              return <ContactSection key={i} data={block} />;

            case "blocks.2025-home-trusted-by":
              return <Trusted key={i} data={block as TrustedByBlock} />;

            case "blocks.2025-home-awards":
              return <Awards key={i} data={block as AwardsBlock} />;

            default:
              return (
                <div
                  key={i}
                  className="text-red-500 p-4 bg-red-50 border border-red-200 rounded-md mt-4 max-w-[1500px] mx-auto"
                >
                  Unknown block type: {block?.__component || "undefined"}
                </div>
              );
          }
        })}
      </div>
    </>
  );
};

export default LocateUS;
